// extracted by mini-css-extract-plugin
module.exports = {"address":"Address_address__Tkfqj","copyIcon":"Address_copyIcon__gW9k3"};